import {createDivIn, createImgIn, createParagraphIn} from '../ui_utils/DomUtils'
import {UIPlayerOptionButtonType} from './UIPlayerOptionsPopup'
import {UIMutePlayer} from './UIMutePlayer'
import {uiGameManager} from '../EntryShared'
import {TranslationObject} from '@colonist/i18n'
import {TradeEmbargoControllerReader} from '@colonist/game-base-types'
import {PlayerColor} from '@colonist/game-states'
import {LobbyImage} from '@colonist/types'

export class UIPlayerOptionsPopupOptionView {
    readonly contentContainer: HTMLDivElement

    buttonContainer: HTMLDivElement
    private readonly buttonText: HTMLParagraphElement
    private readonly buttonIcon: HTMLImageElement

    constructor(container: HTMLDivElement, optionType: UIPlayerOptionButtonType, playerName: string, playerColor: PlayerColor) {
        const isSpectator = uiGameManager.gameController.isPlayerSpectator
        switch(optionType) {
            case UIPlayerOptionButtonType.Report :
                this.buttonContainer = createDivIn(container, 'player-options-dropdown-button')
                this.buttonText = createParagraphIn(this.buttonContainer, {key: 'strings:game.playerOptionsPopup.report'}, 'player-options-dropdown-button-text-red')
                break
            case UIPlayerOptionButtonType.Mute:
                this.buttonContainer = createDivIn(container, `player-options-dropdown-button ${isSpectator ? 'disabled' : ''}`)
                if(UIMutePlayer.isMute(playerName)) {
                    this.buttonText = createParagraphIn(this.buttonContainer, {key: 'strings:game.playerOptionsPopup.unmute'}, 'player-options-dropdown-button-text')
                } else {
                    this.buttonText = createParagraphIn(this.buttonContainer, {key: 'strings:game.playerOptionsPopup.mute'}, 'player-options-dropdown-button-text')
                }
                break
            case UIPlayerOptionButtonType.Profile:
                this.buttonContainer = createDivIn(container, 'player-options-dropdown-button')
                this.buttonText = createParagraphIn(this.buttonContainer, {key: 'strings:game.playerOptionsPopup.viewProfile'}, 'player-options-dropdown-button-text')
                break
            case UIPlayerOptionButtonType.AddFriend:
                this.buttonContainer = createDivIn(container, 'player-options-dropdown-button')
                this.buttonText = createParagraphIn(this.buttonContainer, {key: 'strings:game.playerOptionsPopup.addFriend'}, 'player-options-dropdown-button-text')
                break
            case UIPlayerOptionButtonType.BlockTrades:
                this.buttonContainer = createDivIn(container, `player-options-dropdown-button ${isSpectator ? 'disabled' : ''}`)
                const isTradeBlocked = TradeEmbargoControllerReader.doesPlayer1HaveAnEmbargoAgainstPlayer2(uiGameManager.gameController.tradeState.embargoState, uiGameManager.gameController.myColor, playerColor)
                const text: TranslationObject = isTradeBlocked ? {key: 'strings:game.playerOptionsPopup.unblockTrades'} : {key: 'strings:game.playerOptionsPopup.blockTrades'}
                this.buttonText = createParagraphIn(this.buttonContainer, text, 'player-options-dropdown-button-text')
                break
            case UIPlayerOptionButtonType.Gift:
                this.buttonContainer = createDivIn(container, 'player-options-dropdown-button')
                createImgIn(this.buttonContainer, LobbyImage.StoreGiftMembershipDark)
                this.buttonText = createParagraphIn(this.buttonContainer, {key: 'strings:storePage.sendGift'}, 'player-options-dropdown-button-text')
                break
        }
    }

    setAction(clickAction: () => any) {
        this.buttonContainer.onpointerdown = (event) => {
            event.preventDefault()
            clickAction()
        }
    }

    setButtonAsTopButton(): UIPlayerOptionsPopupOptionView {
        this.buttonContainer.classList.add('player-options-dropdown-button-top')
        return this
    }

    setButtonAsBottomButton(): UIPlayerOptionsPopupOptionView {
        this.buttonContainer.classList.add('player-options-dropdown-button-bottom')
        return this
    }

    setButtonAsSingleButton(): UIPlayerOptionsPopupOptionView {
        this.buttonContainer.classList.add('player-options-dropdown-button-single')
        return this
    }
}
